import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalModel } from '@models/modal.model';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent implements OnInit {
    private animationTime: number = 300;

    constructor(
        private dialogRef: MatDialogRef<ConfirmModalComponent>,
        @Inject(MAT_DIALOG_DATA) public confirmModal: ModalModel
    ) {}

    ngOnInit(): void {
        setTimeout(() => {
            this.confirmModal.open();
        }, 100);
    }

    close(): void {
        this.confirmModal.close();
        setTimeout(() => {
            this.dialogRef.close(false);
        }, this.animationTime);
    }

    accept(): void {
        this.confirmModal.close();
        setTimeout(() => {
            this.dialogRef.close(true);
        }, this.animationTime);
    }
}
